var map = {
	"./1.png": 3189,
	"./2.png": 6870,
	"./3.png": 4102,
	"./4.png": 1681,
	"./5.png": 4037,
	"./6.png": 6370,
	"./Slice 9.png": 5591,
	"./Slice.png": 5354,
	"./ali-pay.png": 7832,
	"./bg_buy_one.png": 126,
	"./bg_customer.png": 175,
	"./bg_customer_line.png": 5135,
	"./bg_customer_line2.png": 8426,
	"./bg_customer_service.png": 1643,
	"./bg_exchange_success.png": 5254,
	"./bg_exchange_success_line.png": 6663,
	"./bg_home_banner.png": 2353,
	"./bg_home_banner_title.png": 9743,
	"./bg_login.png": 2098,
	"./bg_pay_success.png": 654,
	"./bg_pay_success1.png": 2993,
	"./bg_vip.png": 2251,
	"./bg_vip_tab_check.png": 1056,
	"./block.png": 2042,
	"./category/1.png": 4635,
	"./category/2.png": 1466,
	"./category/3.png": 7390,
	"./category/4.png": 9284,
	"./category/5.png": 4997,
	"./category/6.jpg": 6715,
	"./category/7.jpg": 1193,
	"./category/8.jpg": 8039,
	"./close.png": 2266,
	"./contact-bg1.png": 8821,
	"./contact-bg2.png": 6219,
	"./contact-bg3.png": 308,
	"./customer_wxqr.png": 1381,
	"./default.png": 5865,
	"./detail/bg_check.png": 8570,
	"./detail/icon_down.png": 8955,
	"./detail/icon_last.png": 2420,
	"./detail/icon_next.png": 3730,
	"./detail/icon_play-video.png": 9739,
	"./detail/icon_share.png": 8617,
	"./detail/icon_star.png": 1866,
	"./detail/icon_vip-free.png": 4857,
	"./detail/icon_vip.png": 9078,
	"./finger.png": 7879,
	"./home_bg.png": 9382,
	"./icon__customer.png": 93,
	"./icon__recommend.png": 9986,
	"./icon__wechat-white.png": 9605,
	"./icon_alipay.png": 3780,
	"./icon_alipay_1.png": 1219,
	"./icon_avatar.png": 704,
	"./icon_check.png": 4170,
	"./icon_check2.png": 4181,
	"./icon_close.png": 4461,
	"./icon_copy.png": 1396,
	"./icon_custom_made.png": 8351,
	"./icon_customer_check.png": 3589,
	"./icon_customer_logo.png": 6041,
	"./icon_customer_service.png": 8018,
	"./icon_customer_star.png": 7663,
	"./icon_exchange_code.png": 3829,
	"./icon_lihua.png": 5642,
	"./icon_lock.png": 2975,
	"./icon_logo.png": 999,
	"./icon_m_logo.png": 9098,
	"./icon_mobile_logo.png": 3151,
	"./icon_open_vip.png": 7948,
	"./icon_pay_success.png": 2036,
	"./icon_pc.png": 1850,
	"./icon_search.png": 9673,
	"./icon_search2.png": 2529,
	"./icon_wepay.png": 8574,
	"./icon_wepay_1.png": 3359,
	"./icon_wepay_2.png": 9276,
	"./icon_wexin.png": 2443,
	"./logo-2.png": 5995,
	"./menber_bg.png": 6194,
	"./mobile/ad-zsjy.png": 2554,
	"./mobile/ad.png": 4612,
	"./mobile/home.png": 6754,
	"./mobileLine.png": 3977,
	"./month.png": 6136,
	"./month_bg.png": 6155,
	"./month_year.png": 9722,
	"./no-data.png": 6977,
	"./open-vip/bg_buy_month.png": 5444,
	"./open-vip/bg_buy_month2.png": 4931,
	"./open-vip/bg_buy_month2_check.png": 4405,
	"./open-vip/bg_buy_month_check.png": 3318,
	"./open-vip/bg_buy_one.png": 9735,
	"./open-vip/bg_buy_one_check.png": 9436,
	"./open-vip/bg_buy_week.png": 5064,
	"./open-vip/bg_buy_week_check.png": 4116,
	"./open-vip/bg_buy_year.png": 3203,
	"./open-vip/bg_buy_year2.png": 1014,
	"./open-vip/bg_buy_year2_check.png": 2926,
	"./open-vip/bg_buy_year_check.png": 7244,
	"./open-vip/bg_check.png": 4325,
	"./open-vip/bg_modal.png": 1263,
	"./pay-success-bg.png": 7865,
	"./pay-success-bg1.png": 8754,
	"./pay-success-bg2.png": 134,
	"./pay-success-bg3.png": 8645,
	"./paying-bg.png": 2500,
	"./star.png": 6960,
	"./user.png": 4353,
	"./vip.png": 7159,
	"./vipcard/bg_1.png": 6935,
	"./vipcard/bg_2.png": 9414,
	"./vipcard/bg_3.png": 2043,
	"./vipcard/icon_1.svg": 8825,
	"./vipcard/icon_2.svg": 7789,
	"./vipcard/icon_3.svg": 197,
	"./vipcard/icon_4.svg": 4777,
	"./vipcard/icon_5.svg": 2606,
	"./vipcard/icon_6.svg": 1797,
	"./wechat-pay.png": 5878,
	"./week_slice.png": 7237,
	"./year.png": 5351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;